import { Box } from '@mantine/core';
import { useState } from 'react';
import type { BackgroundJob } from '../../../lib/models';
import { useFeatureFlags } from '../../../utils/featureFlags';
import { BackgroundJobProgress } from '../../BackgroundJobProgress';
import { DocumentImport } from './DocumentImport';
import { ExportSettings } from './ExportSettings';
import { ImportSettings } from './ImportSettings';
import { MetaplaneMonitorImportSettings } from './MetaplaneMonitorImportSettings';

export function ImportAndExportSettings() {
	const [backgroundJob, setBackgroundJob] = useState<BackgroundJob | null>(
		null
	);
	const { monitorImport } = useFeatureFlags();

	return (
		<Box>
			{!!backgroundJob && (
				<BackgroundJobProgress key={backgroundJob.id} job={backgroundJob} />
			)}
			<ImportSettings />
			<ExportSettings setBackgroundJob={setBackgroundJob} />
			<DocumentImport />
			{monitorImport && <MetaplaneMonitorImportSettings />}
		</Box>
	);
}
